import React from "react";
import { formatNumber } from "../charts/utils";
import { Instant, ZonedDateTime } from "@js-joda/core";
import { useTimezone } from "hooks/useTimezone";
import { fmtDatetime, toZonedDateTime } from "utils/time-utils";
import { DATE_FORMATTER_DAYS } from "utils/constants";

interface CellProps {
  color: string;
  className?: string;
  value?: number;
  date?: string;
  decimalPlaces?: number;
}

interface MonthProps {
  startDate: ZonedDateTime;
  index: number;
}

interface WeekDayProps {
  index: number;
}

const DayNames: { [key: number]: string } = {
  0: "Mon",
  1: "Tue",
  2: "Wed",
  3: "Thu",
  4: "Fri",
  5: "Sat",
  6: "Sun",
};

const Cell = ({ color, className, value, date, decimalPlaces }: CellProps) => {
  const tz = useTimezone();

  const style = {
    backgroundColor: color,
  };

  const todayDate = ZonedDateTime.now(tz.company).toLocalDate();

  const zonedDateForCalc = date ? toZonedDateTime(date, tz.company) : undefined;

  const displayDate = date
    ? fmtDatetime(date, tz.display, DATE_FORMATTER_DAYS)
    : "";

  return (
    <div className={`timeline-cells-cell ${className}`} style={style}>
      {zonedDateForCalc && zonedDateForCalc.toLocalDate().isAfter(todayDate) ? (
        <div className="dot">.</div>
      ) : null}
      <div className="tooltip">
        {displayDate} {value !== undefined && formatNumber(value, decimalPlaces)}
      </div>
    </div>
  );
};

export default Cell;


const Month = ({ startDate, index }: MonthProps) => {
  const date = startDate.plusWeeks(index);

  const monthName = date.month().toString().substring(0, 3);
  const prettyMonth = monthName.charAt(0) + monthName.slice(1).toLowerCase();

  return <div className={`timeline-months-month ${prettyMonth}`}>{prettyMonth}</div>;
};

const WeekDay = ({ index }: WeekDayProps) => {
  return <div className="timeline-weekdays-weekday">{DayNames[index]}</div>;
};

export { Cell, Month, WeekDay };
